module.exports = __webpack_public_path__ + "static/media/table-bg.97062d31.png";